// extracted by mini-css-extract-plugin
export default {"page":"eY-z","cartModal":"fY-z","checkout":"gY-z","placeholder":"hY-z","account":"iY-z"};